import axios, { AxiosResponse, AxiosError } from 'axios';

export const defaultPaymentHistory: PaymentHistory = {
};

const apiUrl = process.env.REACT_APP_API_URL;
const paymentAPI = {
	createNewCustomerSubscription:
		(userId: number, policyId: string, tokenId: string,
			referralCode?: string, skipDeclineChecker?: boolean, resetPasswordUrl?: string) => {
			const data = { userId, policyId, tokenId, referralCode, skipDeclineChecker, resetPasswordUrl };

			return axios.post(`${apiUrl}/subscriptions/new`, data)
				.then((resp: AxiosResponse) => resp.data)
				.catch((err: AxiosError) => {
					if (err.response) {
						throw err.response.data;
					}
					throw err;
				});
		},
	fetchPayment: (invoiceNumber: string) => {
		return axios.get(`${apiUrl}/payments/${invoiceNumber}.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchCustomerPayment: (userId: string, invoiceNumber: string) => {
		return axios.get(`${apiUrl}/customers/${userId}/payments/${invoiceNumber}.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchCustomerPayments: (userId: string) => {
		return axios.get(`${apiUrl}/customers/${userId}/payments.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchCustomerUpcomingInvoice: (userId: string) => {
		return axios.get(`${apiUrl}/customers/${userId}/invoices/upcoming.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	payInvoice: (invoiceId: string, token?: stripe.Token, customerId?: string) => {
		const data = {
			invoiceId: invoiceId,
			tokenId: token != null ? token.id : null,
			customerId: customerId || null
		};

		return axios.post(`${apiUrl}/invoices/pay`, data)
			.then((resp: AxiosResponse) => resp.data)
			.catch((err: AxiosError) => {
				if (err.response) {
					throw err.response.data;
				}
				throw err;
			});
	},
	fetchCustomerCard: (userId: string) => {
		return axios.get(`${apiUrl}/customers/${userId}/card.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchInvoiceCard: (invoiceId: string) => {
		return axios.get(`${apiUrl}/invoices/${invoiceId}/card.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	updateCustomerCard: (customerId: string, token: stripe.Token) => {
		const data = {
			customerId: customerId,
			tokenId: token.id
		};

		return axios.post(`${apiUrl}/cards/update`, data)
			.then((resp: AxiosResponse) => resp.data);
	},
	updateCustomerPlan: (policy: CustomerPolicy, overwriteRate: boolean) => {
		const data = { ...policy, overwriteRate };

		return axios.post(`${apiUrl}/plans/update`, data)
			.then((resp: AxiosResponse) => resp.data);
	},
};

export default paymentAPI;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/payment/paymentAPI.ts